export const section2DetailsList = [
  {
    stepUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point1_pc.png',
    stepUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point1_m.png',
    step: 'POINT 1',
    title: '스팀 · 모바일 플랫폼 내 \n게임 출시 프로젝트',
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_img1.png',
    delay: 300,
  },
  {
    stepUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point2_pc.png',
    stepUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point2_m.png',
    step: 'POINT 2',
    title: '멀티플레이를 위한 \n서버 · 네트워크 교육',
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_img2.png',
    delay: 500,
  },
  {
    stepUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point3_pc.png',
    stepUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point3_m.png',
    step: 'POINT 3',
    title: '라이엇 · 넥슨 · 네오플 \n전/현직자의 특강',
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_img3.png',
    delay: 700,
  },
  {
    stepUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point4_pc.png',
    stepUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_point4_m.png',
    step: 'POINT 4',
    title: '교육 전담 커리어 팀의 \n이력서 · 자소서 컨설팅',
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section2_img4.png',
    delay: 900,
  },
]

export const projectDetailList = [
  {
    id: 0,
    step: 'Stage 1',
    title: '2D 슈팅게임 & 횡스크롤 \n게임 제작',
    desc: '유니티와 C# 기초를 배워 캐주얼한 게임을 만들고 나만의 게임 제작 스타일을 찾아요',
    contents: [
      {
        contentsImagePc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage1_pc.gif',
        contentsImageM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage1_m.gif',
        contentsDesc: '*이해를 돕기 위한 참고용 Unity 기반 게임 이미지입니다.',
      },
    ],
  },
  {
    id: 1,
    step: 'Stage 2',
    title: '유니티 물리엔진 기반 \n3D 게임 제작',
    desc: '실무에서 사용하는 자료 구조와 각종 패턴을 토대로 본격적인 게임 제작을 시작해요',
    contents: [
      {
        contentsImagePc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage2_pc.gif',
        contentsImageM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage2_m.gif',
        contentsDesc: '*이해를 돕기 위한 참고용 Unity 기반 게임 이미지입니다.',
      },
    ],
  },
  {
    id: 2,
    step: 'Stage 3',
    title: '팀단위 AOS 게임 제작',
    desc: '서버와 네트워크까지 배우고 출시까지 가능한 수준의 게임을 제작해요',
    contents: [
      {
        contentsImagePc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage3_pc.gif',
        contentsImageM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage3_m.gif',
        contentsDesc: '*이해를 돕기 위한 참고용 Unity 기반 게임 이미지입니다.',
      },
    ],
  },
  {
    id: 3,
    step: 'Stage 4',
    title: '온라인 핵앤슬래시 게임 제작',
    desc: '반응형 NPC와 다국어 지원 등 글로벌 출시까지 문제 없는 완성도 높은 게임을 제작해요',
    contents: [
      {
        contentsImagePc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage4_pc.gif',
        contentsImageM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage4_m.gif',
        contentsDesc: '*이해를 돕기 위한 참고용 Unity 기반 게임 이미지입니다.',
      },
    ],
  },
  {
    id: 4,
    step: 'Final Stage',
    title: '자율 주제의 게임 제작 및 \n출시 준비',
    desc: '유료 결제 시스템 연동부터 사업자등록까지 정식 게임 제작자로서 거듭날 수 있는 최종 프로젝트를 진행해요',
    contents: [
      {
        contentsImagePc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage5_pc.gif',
        contentsImageM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_stage5_m.gif',
        contentsDesc: '*이해를 돕기 위한 참고용 Unity 기반 게임 이미지입니다.',
      },
    ],
  },
]

export const section5DetailsList = [
  {
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section5_img1.png',
    step: 'STEP 1',
    title: '구글 플레이 · 앱스토어 배포까지 \n마켓 등록에 필요한 모든 과정 학습',
    delay: 300,
  },
  {
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section5_img2.png',
    step: 'STEP 2',
    title: '1인 개발자도 가능한 \n사업자 등록 및 수익화 준비',
    delay: 500,
  },
  {
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section5_img3.png',
    step: 'STEP 3',
    title: '출시 IR 데이 · 데모데이를 통해 \n투자자 및 실무자 대상 피칭법 학습',
    delay: 700,
  },
  {
    symbolUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section5_img4.png',
    step: 'STEP 4',
    title: '출시 이후 유지보수부터 \n사용자 피드백 대응법까지',
    delay: 900,
  },
]

export const projectOutputList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img1.mp4',
    thumbnailPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img1_thumbnail_pc.png',
    thumbnailM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img1_thumbnail_m.png',
    step: '1',
    title: '3인칭 3D 퍼즐 게임',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img2.mp4',
    thumbnailPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img2_thumbnail_pc.png',
    thumbnailM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img2_thumbnail_m.png',
    step: '2',
    title: '3D 이동형 디펜스 게임',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img3.mp4',
    thumbnailPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img3_thumbnail_pc.png',
    thumbnailM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img3_thumbnail_m.png',
    step: '3',
    title: '멀티 협동 대전 게임',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img4.mp4',
    thumbnailPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img4_thumbnail_pc.png',
    thumbnailM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img4_thumbnail_m.png',
    step: '4',
    title: '디펜스 대전 게임',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img5.mp4',
    thumbnailPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img5_thumbnail_pc.png',
    thumbnailM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img5_thumbnail_m.png',
    step: '5',
    title: '3D 이동형 디펜스 게임',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img6.mp4',
    thumbnailPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img6_thumbnail_pc.png',
    thumbnailM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section6_img6_thumbnail_m.png',
    step: '6',
    title: '멀티 협동 대전 게임',
  },
]

export const curriculumDetailList = [
  {
    id: 0,
    step: '1개월 : 맛보기 던전',
    title: 'C#, Unity 운용이론',
    desc: '기본 이론 학습 후 간단한 게임을 제작하며 전반적인 개발 스킬과 개발 환경에 대해 적응하는 과정이에요',
    url: 'https://www.youtube.com/watch?v=sJ1gHU08Kkk',
    contents: [
      {
        contentsInner: [
          'C# 기초 문법',
          'C# 심화 문법',
          '유니티 코루틴, 비동기 기법',
          '유니티 API 알아보기',
          '유니티 물리 엔진 사용하기',
          '유니티 UI 시스템 만져보기',
          '유니티 3D 기본',
          'StateMachine',
          'Git 기본 사용법, 코드 관리',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: ['2D슈팅게임 · 횡스크롤게임 제작'],
      },
    ],
  },
  {
    id: 1,
    step: '2개월 : 일반 던전',
    title: '게임디자인패턴, 소프트웨어공학',
    desc: '싱글 게임 제작을 위한 게임 패턴, 로직 등을 배우며 실전에서는 어떻게 활용되는지 알아보는 과정이에요',
    url: 'https://www.youtube.com/watch?v=TWubJ23Gymw',
    contents: [
      {
        contentsInner: [
          '실전에서 사용되는 자료구조 Stack · Queue · List · Array · Map · HashMap · Set',
          '실전에서 사용되는 알고리즘 · A* (A-Star) 경로찾기 · 행동 트리 · 유한 상태 기계 · 퍼지 로직',
          '게임 디자인 패턴 · 싱글톤 패턴 · 상태 패턴 · 옵저버 패턴 · 명령 패턴 · 오브젝트 풀링 · 서비스 로케이터 패턴',
          '에디터 커스터마이징 학습',
          '실전에서 쓰이는 데이터 관리 기법 XML · CSV · JSON',
          '상점 시스템',
          '인벤토리 시스템',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: ['유니티 물리엔진 기반 3D게임 1종 제작'],
      },
    ],
  },
  {
    id: 2,
    step: '3개월 : 희귀 던전',
    title: '게임 서버구축 및 네트워크 동기화',
    desc: '쉐이더 기초와 서버, 네트워크, 가상환경 등을 학습하며 본격적으로 완성도 높은 게임을 만들기 위한 과정이에요',
    url: 'https://www.youtube.com/watch?v=WsnT1_c1VkQ',
    contents: [
      {
        contentsInner: [
          'Unity 네트워크 포톤을 이용한 2D게임 · 3D게임 연습',
          'Unity 미러 네트워크 사용법',
          'Unity Netcode 사용법',
          '멀티 플레이 게임에 적용되는 RoomSystem',
          '실전에서 사용되는 알고리즘 A* (A-Star) 경로찾기 행동 트리 유한 상태 기계 퍼지 로직',
          '네트워크 동기화 기초과정 · 락스텝 동기화 · 클라이언트-서버 예측 · 서버 권위 · 상태 동기화',
          '쉐이더 맛보기  Unlit Shader · Water Shader · Outline Shader · Toon Shader · Dissolve Shader · Hologram Shader · Fog Shader · Glass Shader',
          'Netcode를 이용한 멀티플레이게임 만드는 방법',
          'tcp/ip C# 서버를 이용한 Unity +c#서버 오목게임',
          '포트포워딩',
          '팀 단위에서 겪는 Git 해프닝 해결',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: ['Unity 네트워크 2D · 3D 팀 프로젝트'],
      },
    ],
  },
  {
    id: 3,
    step: '4개월 : 영웅 던전',
    title: '쉐이더 심화 및 게임 최적화',
    desc: '쉐이더 심화부터 게임 최적화까지 배우고 팀 단위로 게임을 제작하며 실무와 유사한 수준의 프로젝트를 경험해요',
    url: 'https://www.youtube.com/watch?v=XfpI7cLtn_s',
    contents: [
      {
        contentsInner: [
          '유니티 쉐이더 · 기본 라이팅 셰이더 · 텍스처 매핑 · 토닝 기법 · PBR (Physically Based Rendering) · 포스트 프로세싱 효과 · 환경 효과 · 그림자 기법',
          '각 팀에 맞는 코칭 및 LLM 활용하기 · 코드 생성 및 최적화 · 대화형 NPC (Non-Player Character) 구현 · 상황에 맞는 NPC 반응 생성 · 동적 스토리라인 생성 · 게임 문서화 · 테스트 케이스 생성 · 다국어 지원',
          '한번에 대량의 GameObject 생성 시 나타날 수 있는 문제들 해결',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: ['팀 단위 멀티 플레이 핵엔슬래시 게임 제작'],
      },
    ],
  },
  {
    id: 4,
    step: '5개월 : 전설 던전',
    title: '게임 프레임워크 제작',
    desc: '게임 출시를 위해 필요한 디테일한 부분까지 배우며 그동안 꿈꿔왔던 종류의 게임을 내 손으로 직접 만들기 시작해요',
    url: 'https://www.youtube.com/watch?v=l9hb4z6d0iU',
    contents: [
      {
        contentsInner: [
          '게임 아이디어 구상 및 기획서 작성',
          '게임 프레임워크 제작 · 렌더링 시스템 관리 · 물리 엔진 관리 · 오디오 시스템 관리 · 입력 관리 · 리소스 관리 · 네트워킹 관리 · UI 시스템 관리 · 씬 관리 · 데이터 관리 · 이벤트 시스템',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: ['팀 단위 자율 주제 포트폴리오 제작 및 출시 (스팀 · 모바일)'],
      },
    ],
  },
  {
    id: 5,
    step: '6개월 : 카오스 던전',
    title: '게임 출시 프로세스 학습',
    desc: '결제 시스템 연동부터 출시 프로세스까지 배워 정식 게임 제작자로서 첫걸음을 떼는 순간이에요',
    url: 'https://www.youtube.com/watch?v=v3oLSJzSXo0',
    contents: [
      {
        contentsInner: [
          '네트워크 동기화 심화과정 \n델타 압축 · 보간과 외삽 · 타임스탬프 동기화 · 롤백과 재실행 · 영역 기반 관심사 · 지연보상기법 실전에서 사용되는 알고리즘 A* (A-Star) 경로찾기 행동 트리 유한 상태 기계 퍼지 로직',
          '결제 시스템 연동',
          '플랫폼별 출시 방법 - Android · iOS · Steam',
          '소셜 로그인 연동 방법 - Naver, Kakao, Google',
          '게임에 광고 넣기',
          '출시를 위한 최적화 및 디버깅 기법',
          '출시를 위한 사업자등록',
        ],
      },
      {
        contentsIntro: '프로젝트',
        contentsInner: ['팀 단위 자율 주제 포트폴리오 제작 및 출시 (스팀 · 모바일)'],
      },
    ],
  },
]

export const section8DetailsList = [
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img1_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img1_m.png',
    step: '기초반 운영',
    title: 'C# 기초와 유니티 기초 프로그램, \n처음부터 차근차근 익히는 기초반 운영',
    desc: '개강 직후 학습 수준을 진단하고, \n그 결과에 따라 맞춤형 수업을 소규모 그룹 또는 1:1로 제공해요',
    delay: 300,
  },
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img2_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img2_m.png',
    step: '현직자 멘토링',
    title: '1:1 또는 그룹 단위의 밀착 케어, \n실시간 피드백 제공',
    desc: '혼자 고민하지 않아도 돼요, 게임 업계 실무 경험이 풍부한 현직 전문가들이 여러분의 여정을 끝까지 서포트해요',
    delay: 500,
  },
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img3_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img3_m.png',
    step: '그로우 메이트',
    title: '함께 성장하는 스터디 & \n팀 프로젝트 운영',
    desc: '같은 목표를 가진 동료들과 함께 기초부터 탄탄하게 다질 수 있어요',
    delay: 700,
  },
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img4_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section8_img4_m.png',
    step: '사전 강의 자료 제공',
    title: '미리 학습할 수 있는 \n사전 강의 자료 제공',
    desc: 'C#과 유니티가 처음인 비전공자도 부담 없이 준비할 수 있도록 구성되어 있어요',
    delay: 900,
  },
]

export const benefitDetailList = [
  {
    id: 0,
    point: 'POINT 01',
    title: '취업 방향성 탐색',
    contents: [
      '현직 개발자의 특강',
      '개별 진로 탐색, 취업 로드맵 수립, 포트폴리오 작업 방향성 탐색',
    ],
  },
  {
    id: 1,
    point: 'POINT 02',
    title: '취업 역량 강화',
    contents: [
      '이력서/자기소개서 작성 방법 특강 진행 (이력서 양식 및 대기업 합격 자기소개서 샘플 포함)',
      'IT 전문 취업 컨설턴트의 포트폴리오 꿀팁 대방출',
      '가장 강력한 포트폴리오인 게임 출시를 위해 사업자등록부터 플랫폼별 출시 과정까지 경험하여 독보적인 차별점 획득',
    ],
  },
  {
    id: 2,
    point: 'POINT 03',
    title: '수료 후 지속 케어',
    contents: [
      '교육 과정 수료 이후에도 지속적인 구직활동 현황 체크',
      '스타트업 인사팀장 출신 코치의 1:1 상담 프로그램 지원',
      '수료 후 6개월간 이력서 및 포트폴리오 첨삭 제공',
      'IT 전 직무 수료생이 모인 ”세렝게티“ 네트워크를 통한 스터디, 프로젝트, IT 취업정보 공유',
    ],
  },
]

export const benefitSlideList = [
  {
    title: 'Unity 공식 교육 라이센스 제공',
    desc: '유니티 코리아에서 공식적으로 제공하는\n교육기관용 라이센스(인당 80만원 상당)를\n무료로 제공해 드려요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img1.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img1_m.png',
  },
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,700만원 상당의 교육을\n무료로 들을 수 있어요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img2.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img2_m.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 81만원 상당의\n훈련장려금이 지급돼요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img3.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img3_m.png',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 전, 교육 장비가 필요한 인원에 한하여\n무료로 장비를 대여해 드려요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img4.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img4_m.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 있는\n오프라인 공간을 지원해요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img5.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img5_m.png',
  },
  {
    title: '교육에 필요한 참고 도서 지원',
    desc: '교육에 참여하는 모든 인원에게\n참고 도서를 무상으로 지원해 드려요',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img6.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-3rd/benefit_slide_img6_m.png',
  },
]

export const reviewList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section12_img1.png',
    review:
      '단순히 유니티의 사용 방법에 대한 교육을 넘어, 게임이라는 매체에 대한 더 높은 이해도를 가질 수 있었던 강의였어요.',
    highlights: ['게임이라는 매체에 대한 더 높은 이해도'],
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section12_img2.png',
    review:
      '수강생들과의 적극적인 소통을 통해 운영 기간 동안 이루어지는 개선이 인상 깊었습니다. \n교육 내용도 유익한 부분이 많아 유니티 개발에 정말 큰 도움이 되었습니다.',
    highlights: ['수강생들과의 적극적인 소통'],
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section12_img3.png',
    review:
      '정말 만족합니다. 한 명도 빠짐없이 끝까지 끌고 가시려는 의지가 느껴져서 가장 좋았습니다.',
    highlights: ['한 명도 빠짐없이 끝까지 끌고 가시려는 의지'],
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section12_img4.png',
    review:
      '너무나도 훌륭한 과정이라고 생각합니다. 고민하는 분이 있다면 망설일 시간에 지원하라고 권유할 것 같아요. \n좋은 과정 만들어주셔서 감사하고, 배운 걸 잘 갈고닦아 온전히 제 것으로 만들어보겠습니다. 감사합니다.',
    highlights: ['고민하는 분이 있다면 망설일 시간에 지원하라고 권유'],
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section12_img5.png',
    review:
      '유니티뿐만 아니라 게임 개발에 필요한 전공 지식부터 전반적인 지식과 사고 능력까지 기를 수 있었고, \n다양한 수강생들과의 협업도 좋은 경험이 되었습니다.',
    highlights: ['게임 개발에 필요한 전공 지식부터 전반적인 지식과 사고 능력'],
  },
]

export const applyScheduleList = [
  {
    title: '합격자 발표일',
    content: '지원서 제출 후 7일 이내 결과 안내 (영업일 기준)',
  },
]

export const eduScheduleList = [
  {
    title: 'OT&개강',
    content: '2025년 05월 13일 (화) 오후 1시',
  },
  {
    title: '교육 기간',
    content: '2025년 05월 13일 (화) ~ \n2025년 11월 12일 (수)',
  },
  {
    title: '교육 시간',
    content: '920시간 / 평일 9시 ~ 18시 \n(점심시간 12시~13시 제외)',
  },
  {
    title: '학습 형태',
    content: '실시간 온라인 교육',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. \n단, 미성년자의 경우 참여가 어렵다는 점을 안내드립니다. \n발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. 국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기(링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 앱 카드 발급 방법 확인하기(링크)',
    },
    {
      question: '[지원] 고용24 수강신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 유니티 게임 개발자가 되려는 강한 의지와 계획이 있으시면 됩니다. \n다만, 합격 후 6개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 발급 → 지원서 및 과정 적합성 검사 제출 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 과정 적합성 검사는 무엇인가요?',
      answer:
        '부트캠프 합류에 앞서 유니티에 대한 기본 이해와 취업에 대한 의지를 확인하고자 하는 누구나 답할 수 있는 간단한 검사입니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '현직 개발자의 특강 및 면접 관련 프로그램을 지원합니다. 또한 최신 채용 트렌드를 반영한 전문적인 이력서 특강 및 피드백을 통한 취업 지원을 받으실 수 있습니다. \n*제공되는 프로그램 항목은 내부 사정에 의해 변경될 수 있습니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다.\n 1. 고용24 앱 설치 후 QR코드 인증(개인 진행)\n 2. 줌 모니터링을 통한 매 시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정)\n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 6개월동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
    {
      question: '[교육 운영] 교육 중간에 결석하게 될 경우, 어떻게 되나요?',
      answer:
        '불가피한 사정(질병, 가족 돌봄 등)이 있을 경우에는 관련 증빙을 제출하면 출석으로 인정받을 수 있어요. \n또한, 지각·조퇴·외출도 일정 기준 내에서는 유연하게 처리되지만, 누적될 경우 결석으로 간주될 수 있으니 유의해 주세요. \n만약 중도에 수강이 어려워지는 상황이 생겼다면, 너무 걱정하지 마세요. 특수한 상황에는 패널티 없이 수강을 종료할 수 있으며, 상황에 따라 이후의 국비지원 참여도 가능해요. \n어려운 상황이 생기면 언제든 운영진과 먼저 상의해 주세요. 최대한 수강생 분들의 상황을 고려해 도와드릴게요.',
    },
  ],
  benefit: [
    {
      question: '[혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answerList: [
        '· 네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다.',
        '· 국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. 다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
      ],
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
